import Evaluator from "./Evaluator"
import ContextualEvaluator from "./ContextualEvaluator"
import EvaluateRequest from "../EvaluateRequest"
import EvaluateResponse from "../EvaluateResponse"
import ExperimentEvaluateRequest from "../service/experiment/ExperimentEvaluateRequest"
import ExperimentEvaluator from "../service/experiment/ExperimentEvaluator"
import RemoteConfigEvaluateRequest from "../service/remoteconfig/RemoteConfigEvaluateRequest"
import RemoteConfigEvaluator from "../service/remoteconfig/RemoteConfigEvaluator"
import { InAppMessageEligibilityEvaluateRequest } from "../service/inappmessage/eligibility/InAppMessageEligibilityEvaluateRequest"
import InAppMessageEligibilityEvaluator from "../service/inappmessage/eligibility/InAppMessageEligibilityEvaluator"
import { InAppMessageLayoutEvaluateRequest } from "../service/inappmessage/layout/InAppMessageLayoutEvaluateRequest"
import InAppMessageLayoutEvaluator from "../service/inappmessage/layout/InAppMessageLayoutEvaluator"

export default class EvaluatorFactory {
  private readonly evaluators: ContextualEvaluator<EvaluateRequest, EvaluateResponse>[] = []

  add<REQ extends EvaluateRequest, RESP extends EvaluateResponse>(evaluator: ContextualEvaluator<REQ, RESP>): void {
    this.evaluators.push(evaluator as unknown as ContextualEvaluator<EvaluateRequest, EvaluateResponse>)
  }

  get(request: EvaluateRequest): Evaluator<EvaluateRequest, EvaluateResponse> {
    const evaluator = this.evaluators.find((it) => it.supports(request))
    if (!evaluator) {
      throw new Error(`Unsupported evaluate request [${request.constructor.name}]`)
    }
    return evaluator
  }

  experiment(request: ExperimentEvaluateRequest): ExperimentEvaluator<ExperimentEvaluateRequest> {
    return this.get(request) as ExperimentEvaluator<ExperimentEvaluateRequest>
  }

  remoteConfig(request: RemoteConfigEvaluateRequest): RemoteConfigEvaluator<RemoteConfigEvaluateRequest> {
    return this.get(request) as RemoteConfigEvaluator<RemoteConfigEvaluateRequest>
  }

  inAppMessageEligibility(
    request: InAppMessageEligibilityEvaluateRequest
  ): InAppMessageEligibilityEvaluator<InAppMessageEligibilityEvaluateRequest> {
    return this.get(request) as InAppMessageEligibilityEvaluator<InAppMessageEligibilityEvaluateRequest>
  }

  inAppMessageLayout(
    request: InAppMessageLayoutEvaluateRequest
  ): InAppMessageLayoutEvaluator<InAppMessageLayoutEvaluateRequest> {
    return this.get(request) as InAppMessageLayoutEvaluator<InAppMessageLayoutEvaluateRequest>
  }
}
